import {
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
  ViewEncapsulation,
} from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatIcon, MatIconModule } from "@angular/material/icon";
import {
  Router,
  RouterLink,
  RouterOutlet,
} from "@angular/router";
import { FuseFullscreenComponent } from "@fuse/components/fullscreen";
import { FuseLoadingBarComponent } from "@fuse/components/loading-bar";
import {
  FuseNavigationService,
  FuseVerticalNavigationComponent,
} from "@fuse/components/navigation";
import { FuseMediaWatcherService } from "@fuse/services/media-watcher";
import { NavigationService } from "app/core/navigation/navigation.service";
import { Navigation } from "app/core/navigation/navigation.types";
import { UserService } from "app/core/user/user.service";
import { User } from "app/core/user/user.types";
import { UserComponent } from "app/layout/common/user/user.component";
import { Subject, takeUntil } from "rxjs";
import { HelperService } from "../../../core/services/helper/helper.service";
import { CommonConstants } from "../../../core/constants/common-constants";
import { CommonModule, Location } from "@angular/common";
import { BrandService } from "app/modules/admin/brand-management/brand.service";
import { AccountService } from "app/modules/admin/settings/account/account.service";
import { MatFormField, MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatSelectModule } from "@angular/material/select";
import { FormsModule } from "@angular/forms";

@Component({
  selector: "classy-layout",
  templateUrl: "./classy.component.html",
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [
    FuseLoadingBarComponent,
    FuseVerticalNavigationComponent,
    UserComponent,
    MatIconModule,
    MatButtonModule,
    RouterOutlet,
    RouterLink,
    MatFormFieldModule,
        MatInputModule,
        CommonModule,
        MatIcon, MatFormField, MatSelectModule,FormsModule
        
  ],
})
export class ClassyLayoutComponent implements OnInit, OnDestroy {
  isScreenSmall: boolean;
  navigation: any;
  user: any;
  userRowData: any;
  pageName: any = "";
  parts: any;
  firstPart: any
  restPart: any
  private _unsubscribeAll: Subject<any> = new Subject<any>();
  brands: any = []
    profileData: any = []
    brandList: any = []
    isPartner: any;
    brandStatusValue: any = '';

  /**
   * Constructor
   */
  constructor(
    private _router: Router,
    private _navigationService: NavigationService,
    private _userService: UserService,
    private _fuseMediaWatcherService: FuseMediaWatcherService,
    private _fuseNavigationService: FuseNavigationService,
    private _helper: HelperService,
    private cdr: ChangeDetectorRef,
    private _location : Location,
    private _brandService: BrandService,
    private _acService: AccountService
  ) {
    this.isPartner = ((this._router.url.indexOf('/partner') !== -1 || window.location.origin.indexOf('partners') !== -1)); 
    if(this._router.url.indexOf('/partner-management') != -1){
            this.isPartner = false
        }
    this.getBrandList();
    this._helper.pageName.subscribe((res: any) => {
      if (res) {
        this.pageName = res;
        this.getBreadcrumbHtml(res)
        this.cdr.detectChanges();
      }
    });
    let user: any;
    user = this._helper.getLocalStorageData(CommonConstants.USER_DATA);
    if (user) {
      this.userRowData = user;
    } else {
      // this._router.navigate(['partner/sign-in']);
    }
  }

    /**
     * Summary: This method is use for get brand list
     */
    async getBrandList() {
      this._brandService.brandList({ status: 1 }).subscribe(async (res: any) => {
        if (res?.meta?.status == 1) {
          this.brands = (await res?.data)?.sort((a: any, b: any) =>
            (a.brandNameEn || "").localeCompare(b.brandNameEn || "")
          );
          // if(this.isPartner){
          this.getProfileDataForBrands();
          // }
        } else {
        }
      });
    }
  
    async getProfileDataForBrands(){
      this._acService.viewAccount(this.isPartner).subscribe(async (res: any) => {
              if(res?.meta?.status == 1){
                this.profileData = await res?.data;
                if(this.isPartner){
                   this._helper.setLocalStorageData(
                    CommonConstants.PARTNER_PROFILE,
                    res?.data
                  );
                  this.brandList = this.brands
                    ?.filter((brand: any) => res?.data?.brands?.includes(brand.brandId))
                    .sort((a: any, b: any) =>
                      (a.brandNameEn || "").localeCompare(b.brandNameEn || "")
                    );
                  this._helper.brandListData.next(this.brandList);
                  this.brandStatusValue = "";
                  this._helper.setFilter(this.brandStatusValue);
                  this.cdr.detectChanges();
            } else {
                this._helper.setLocalStorageData(CommonConstants.USER_DATA, res?.data);
              }
              } else {
  
              }
           })
    }
  
  //   generateBrandMenus(brands: any, navigationData: any) {
  //   const brandMenus = brands.map(brand => ({
  //     id: brand.brandNameEn.toLowerCase().replace(/\s+/g, '-'),
  //     title: `${brand.brandNameEn}`,
  //     type: 'basic',
  //     icon: 'heroicons_outline:user-group',
  //     link: `/partner/${brand.brandNameEn}/${brand.brandId}`,
  //     permissions: {
  //       only: ['PARTNER']
  //     },
  //     brandId: brand.brandId,
  //     brandLogo: brand.brandLogo
  //   }));
    
  //   navigationData.default = [navigationData.default[1], ...brandMenus,...navigationData.default.slice(2)];
  //   return navigationData
  // }

  brandFilter(value: string){
      this._helper.setFilter(value);
      this._helper.setLocalStorageData('BFV', value);
  }

  getBreadcrumbHtml(data: any) {
    this.parts = data.split(">");
    if (this.parts?.length > 0) {
      this.firstPart = this.parts[0].trim();
      this.restPart = this.parts.slice(1).join(" > ");
    } else {
        this.pageName = data;
    }
    return this.pageName;
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Accessors
  // -----------------------------------------------------------------------------------------------------

  /**
   * Getter for current year
   */
  get currentYear(): number {
    return new Date().getFullYear();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit(): void {
    // Subscribe to navigation data
    this._navigationService.navigation$
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((navigation: Navigation) => {
        this.navigation = navigation;
        // if(this.isPartner){
        //   this.getBrandList(navigation); 
        // } else {
        //   this.navigation = navigation;
        // }
      });

    // Subscribe to the user service
    this._userService.user$
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((user: User) => {
        this.user = user;
      });

    // Subscribe to media changes
    this._fuseMediaWatcherService.onMediaChange$
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe(({ matchingAliases }) => {
        // Check if the screen is small
        this.isScreenSmall = !matchingAliases.includes("md");
      });
  }

  /**
   * On destroy
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Toggle navigation
   *
   * @param name
   */
  toggleNavigation(name: string): void {
    // Get the navigation
    this.handleWardrobeTabActivation();
    const navigation =
      this._fuseNavigationService.getComponent<FuseVerticalNavigationComponent>(
        name
      );

    if (navigation) {
      // Toggle the opened status
      navigation.toggle();
    }
  }

  goBack(page: any){
    if(page == 'Order Management  >View Order' || page == 'Order Management  > View user'){
      this._router.navigate(this.isPartner ? ['partner/order-management'] : ['order-management'])
    } else {
      this._location.back();
    } 
  }

  handleWardrobeTabActivation(): void {
    setTimeout(() => {
      window.dispatchEvent(new Event("resize"));
      setTimeout(() => {
        window.dispatchEvent(new Event("resize"));
      }, 200);
    }, 100);
  }
}
